<script lang="ts">
	import slugify from 'slugify';
	import 'overlayscrollbars/overlayscrollbars.css';
	import { OverlayScrollbars } from 'overlayscrollbars';
	import { onMount } from 'svelte';
	import { resetPage } from '../stores/filter';

	let {
		name,
		mode,
		options,
		selectedItems = $bindable(),
	}: {
		name: string;
		mode: string;
		options: Record<string, number>;
		selectedItems: string[];
	} = $props();
	let list: HTMLElement;

	onMount(() => {
		const osInstance = OverlayScrollbars(list, {
			overflow: { x: 'hidden', y: 'scroll' },
			scrollbars: {
				visibility: 'auto',
			},
		});
	});
</script>

<div class="content filter__facet" bind:this={list}>
	<ul class=" ">
		{#each Object.entries(options) as [key, value] (key)}
			<li>
				<input
					{name}
					type="checkbox"
					class="visually-hidden"
					id={slugify(mode + '-' + key)}
					bind:group={selectedItems}
					value={key}
					onchange={resetPage}
				/>
				<label for={slugify(mode + '-' + key)}>{key} ({value})</label>
			</li>
		{/each}
	</ul>
</div>

<style>
	:global(.os-scrollbar) {
		/* The size of the scrollbar */
		--os-size: 6px;
		/* The axis-perpendicular padding of the scrollbar (horizontal: padding-y, vertical: padding-x) */
		--os-padding-perpendicular: 2px;
		/* The axis padding of the scrollbar (horizontal: padding-x, vertical: padding-y) */
		--os-padding-axis: 0;
		/* The border radius of the scrollbar track */
		--os-track-border-radius: 0;
		/* The background of the scrollbar track */
		--os-track-bg: repeating-linear-gradient(
			rgb(255 255 255 / 0.5),
			rgb(255 255 255 / 0.5) 2px,
			transparent 2px,
			transparent 7px
		);
		/* The :hover background of the scrollbar track */
		--os-track-bg-hover: var(--os-track-bg);
		/* The :active background of the scrollbar track */
		--os-track-bg-active: var(--os-track-bg);
		/* The border of the scrollbar track */
		--os-track-border: none;
		/* The :hover background of the scrollbar track */
		--os-track-border-hover: none;
		/* The :active background of the scrollbar track */
		--os-track-border-active: none;
		/* The border radius of the scrollbar handle */
		--os-handle-border-radius: 0;
		/* The background of the scrollbar handle */
		--os-handle-bg: var(--color-white);
		/* The :hover background of the scrollbar handle */
		--os-handle-bg-hover: var(--os-handle-bg);
		/* The :active background of the scrollbar handle */
		--os-handle-bg-active: var(--os-handle-bg);
		/* The border of the scrollbar handle */
		--os-handle-border: none;
		/* The :hover border of the scrollbar handle */
		--os-handle-border-hover: none;
		/* The :active border of the scrollbar handle */
		--os-handle-border-active: none;
		/* The min size of the scrollbar handle */
		--os-handle-min-size: 33px;
		/* The max size of the scrollbar handle */
		--os-handle-max-size: none;
		/* The axis-perpendicular size of the scrollbar handle (horizontal: height, vertical: width) */
		--os-handle-perpendicular-size: 100%;
		/* The :hover axis-perpendicular size of the scrollbar handle (horizontal: height, vertical: width) */
		--os-handle-perpendicular-size-hover: 300%;
		/* The :active axis-perpendicular size of the scrollbar handle (horizontal: height, vertical: width) */
		--os-handle-perpendicular-size-active: 300%;
		/* Increases the interactive area of the scrollbar handle. */
		--os-handle-interactive-area-offset: 10px;
	}

	:global(.os-scrollbar-vertical .os-scrollbar-handle) {
		transition:
			right 0.15s,
			opacity 0.15s,
			background-color 0.15s,
			border-color 0.15s,
			width 0.15s;
	}
	:global(.os-scrollbar-vertical:hover .os-scrollbar-handle) {
		right: -2px;
	}
</style>
